import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { ButtonBasic, DateRangeMaxSeven, DateSingle, SelectTipoFechasAlert } from '../../components';
import FechaFunction from '../../function/FechaFunction';
import AlertDateSalesService from '../../services/alertDateSales.service';

const ModalAlertDateSales = ({show, hideModal, item, onGuardar, type}) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [fechas, setFechas] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [formAll, setFormAll] = useState({
        titulo_das: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipoAvisoHs_das: {
            texto: null,
            textoErr: 'El tipo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {
            fechaVentaAviso_das: fechas?.startDate,
            fechaVisitaPactada_das: fechas?.endDate
        };
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['titulo_das','tipoAvisoHs_das']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_das > 0) {
                form.id_das = item.id_das
                await AlertDateSalesService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }else{
                await AlertDateSalesService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.titulo_das,'titulo_das')
                onChangeForm(item?.tipoAvisoHs_das,'tipoAvisoHs_das')
                if(item?.fechaVentaAviso_das && item?.fechaVisitaPactada_das){
                    setFechas({
                        startDate: FechaFunction.format(item?.fechaVentaAviso_das,'yyyy-MM-dd'),
                        endDate: FechaFunction.format(item?.fechaVisitaPactada_das,'yyyy-MM-dd'),
                    })
                }
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: '#000',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: 'gray',
            height: 45,
        }
    }), []);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_das > 0 ? 'Editar Fecha de Alerta' : 'Registrar Fecha de Alerta'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Titulo</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.titulo_das.texto}
                                error={formAll.titulo_das.estadoErr}
                                helperText={formAll.titulo_das.estadoErr && formAll.titulo_das.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'titulo_das')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Divider sx={{background: 'gray'}} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    color: '#000',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    mb: 1,
                                    textDecoration: 'underline'
                                }}
                                variant='h5'
                            >
                                Seleccion de fechas
                            </Typography>
                            <DateRangeMaxSeven
                                isFullWidth
                                minDate={new Date()}
                                texto1='Fecha de Venta'
                                texto2='Fecha de Visita'
                                initianDate={fechas}
                                onChange={(e)=>{
                                    let startDate;
                                    let endDate;
                                    if(e?.startDate){
                                        startDate = FechaFunction.format(e?.startDate,'yyyy-MM-dd')
                                    }
                                    if(e?.endDate){
                                        endDate = FechaFunction.format(e?.endDate,'yyyy-MM-dd')
                                    }else{
                                        endDate = FechaFunction.format(e?.startDate,'yyyy-MM-dd')
                                    }
                                    if(e?.startDate){
                                        setFechas({
                                            startDate,
                                            endDate
                                        })
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Tiempo de alerta</Typography>
                            <SelectTipoFechasAlert
                                value={formAll.tipoAvisoHs_das.texto}
                                onChange={(e)=>onChangeForm(e?.value, 'tipoAvisoHs_das')}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalAlertDateSales;